import {
    FETCH_USER_PERMISSIONS,
    FETCH_USER_PERMISSIONS_FAIL,
    FETCH_USER_PERMISSIONS_SUCCESS,
    LOGIN,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT,
    RESET_USERNAME_PASSWORD,
    SESSION_ENDED,
    SET_PASSWORD,
    SET_USERNAME
} from './actionTypes';

export const login = args => ({
    type: LOGIN,
    payload: args
});

export const loginSuccess = response => ({
    type: LOGIN_SUCCESS,
    payload: response
});

export const loginFail = error => ({
    type: LOGIN_FAIL,
    payload: error
});

export const logout = response => ({
    type: LOGOUT,
    payload: response
});

export const sessionEnded = () => ({
    type: SESSION_ENDED
});

export const setUsername = username => ({
    type: SET_USERNAME,
    payload: username
});

export const setPassword = password => ({
    type: SET_PASSWORD,
    payload: password
});

export const resetUsernamePassword = () => ({
    type: RESET_USERNAME_PASSWORD
});

export const fetchUserPermissions = ({ userId }) => ({
    type: FETCH_USER_PERMISSIONS,
    payload: { userId }
});

export const fetchUserPermissionsSuccess = ({ permissions }) => ({
    type: FETCH_USER_PERMISSIONS_SUCCESS,
    payload: { permissions }
});

export const fetchUserPermissionsFail = ({ error }) => ({
    type: FETCH_USER_PERMISSIONS_FAIL,
    payload: { error }
});
